export const TOGGLE_ACTIVE = 'timer/TOGGLE_ACTIVE';
export const RESET_ACTIVE = 'timer/RESET_ACTIVE';
export const CHANGE_FULL_TIME = 'timer/CHANGE_FULL_TIME';
export const UPDATE_ACTIVE_TIME = 'timer/UPDATE_ACTIVE_TIME';
export const UPDATE_FIRST_RUN = 'timer/UPDATE_FIRST_RUN';

export const CREATE_CUSTOM_TIMER = 'timer/CREATE_CUSTOM_TIMER';
